module.exports = __webpack_public_path__ + "static/media/Unbook.d496cde5.svg";